import { FeatureTypes, isFeatureEnable } from '@common/lib/featureToggle';
import InfoIcon from '@mui/icons-material/Info';
import type { Theme } from '@mui/material';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import type { StyleRules, WithStyles } from '@mui/styles';
import createStyles from '@mui/styles/createStyles';
import withStyles from '@mui/styles/withStyles';

const styles = (theme: Theme): StyleRules =>
  createStyles({
    info: {
      margin: `0 0 ${theme.spacing(4)} 0`,
      padding: theme.spacing(),
      border: `solid 2px ${theme.palette.error.main}`,
      borderRadius: 5
    },
    infoIcon: {
      fill: theme.palette.info.main,
      margin: `0 ${theme.spacing()}`
    }
  });

type OwnProps = {
  inBusiness: boolean;
};

type UnapprovedMessageProps = OwnProps & WithStyles<typeof styles>;

const messages = [
  'この申込みサイトでは、デジタルギフトおよび各種サービスのお申し込みを行うことができます。このままお申し込みおよび審査の提出を進めてください。',
  'アカウント情報の確認が完了し次第、申請されたギフトおよびクリエイティブの審査が開始されます。アカウント情報に不備等がある場合には弊社担当よりご連絡いたします。',
  'お申込みサイトの利用方法や弊社サービス全般でご不明な点がありましたら、右上の「よくある質問」をご確認ください。'
];

const UnapprovedMessage: React.FC<UnapprovedMessageProps> = ({
  inBusiness,
  classes
}) => {
  return inBusiness ? null : (
    <Grid
      container
      item
      wrap="nowrap"
      alignItems="center"
      xs={12}
      className={classes.info}
      data-cy="unapprovedMessage"
    >
      <InfoIcon className={classes.infoIcon} fontSize="large" />
      <ul>
        {messages.map(message => (
          <li key={message}>
            <Typography variant="body2" color="textPrimary">
              {message}
            </Typography>
          </li>
        ))}
      </ul>
    </Grid>
  );
};

export default withStyles(styles)(UnapprovedMessage);
